import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

function Layout() {
	return (
		<>
			<ToastContainer />
			<Outlet />
		</>
	);
}

export default Layout;
